<template>
  <div :class="['page-wrapper', { 'tg-frame': isTGFrame }]">
    <!-- ==================== 城市拦截：下载引导页 ==================== -->
    <div v-if="pageMode === 'intercept'" class="download-box">
      <h1 class="main-title">
        <img src="../../assets/images/entryThemeOne/result-loan-user.png" alt="" />
      </h1>
      <div class="main-content u-text-center">
        <div class="trapezoid">安全合规</div>
        <div class="auth-success">
          <p>最高可借额度(元)</p>
          <h2>200,000</h2>
        </div>
        <div class="credit-module bg-rotate">
          <div class="speed-channel">
            <div class="channel-info">
              <!-- 合规调整：移除极速通道及固定速度比例宣传。 -->
              <p class="speed-info">
                放款速度
                <span class="speed-icon">
                  <img src="../../assets/images/entryThemeOne/icon-up-arrow.png" alt="" />
                </span>
              </p>
            </div>
            <p class="speed-quotation">专享资格</p>
          </div>
        </div>
        <van-button class="download-btn" type="default" @click="onUserDownloadClick">
          <img
            class="download-icon"
            src="../../assets/images/entryThemeOne/down-vector.png"
            alt=""
          />
          <!-- 下载操作仅由用户主动触发，拦截结果页不再倒计时自动跳转。 -->
          <span>下载APP 匹配更多资金</span>
        </van-button>
        <p class="download-tips">*页面额度仅供参考，实际下款金额以最终审批为准</p>
      </div>
      <div class="tips-section">
        <p class="tips-text">
          温馨提示：未经您的明示许可，本平台不会对您的个人信息进行任何处理行为。请谨防第三方短信、电话诈骗，确保您的隐私与资金安全
        </p>
      </div>
      <div class="steps-section">
        <div class="steps-title">
          <img
            class="header-line left"
            src="../../assets/images/entryThemeOne/header-line.png"
            alt=""
          />
          <span class="steps-title-text">产品优势</span>
          <img class="header-line" src="../../assets/images/entryThemeOne/header-line.png" alt="" />
        </div>
        <div class="steps-container">
          <div class="step-item">
            <div class="step-icon">
              <img src="../../assets/images/entryThemeOne/step_2.png" alt="" />
            </div>
            <div class="step-text">灵活额度</div>
          </div>
          <div class="step-arrow">
            <img src="../../assets/images/entryThemeOne/step_arrow.png" alt="" />
          </div>
          <div class="step-item">
            <div class="step-icon">
              <img src="../../assets/images/entryThemeOne/step_3.png" alt="" />
            </div>
            <!-- 合规调整：使用中性流程名称，不承诺审批速度。 -->
            <div class="step-text">资料审核</div>
          </div>
          <div class="step-arrow">
            <img src="../../assets/images/entryThemeOne/step_arrow.png" alt="" />
          </div>
          <div class="step-item">
            <div class="step-icon">
              <img src="../../assets/images/entryThemeOne/step_4.png" alt="" />
            </div>
            <div class="step-text">安全保障</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 公共 Loading 视图：静态展示和正式执行共用，业务只控制进度值与启动时机。 -->
    <div v-else class="loading-box">
      <div class="loading-light loading-light-left"></div>
      <div class="loading-light loading-light-right"></div>
      <div class="loading-brand"><span></span>闪借花智能匹配</div>
      <div class="loading-title">正在评估您的专属方案</div>
      <div class="loading-desc">多维数据加密分析中，请稍候</div>

      <div class="progress-wrapper">
        <div class="glow"></div>
        <div class="orbit orbit-outer"><i></i><i></i><i></i></div>
        <div class="orbit orbit-inner"><i></i><i></i></div>
        <svg width="260" height="260">
          <defs>
            <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#ff7a3c" />
              <stop offset="100%" stop-color="#ffb48c" />
            </linearGradient>
          </defs>
          <circle class="bg-circle" cx="130" cy="130" r="100" />
          <circle
            class="progress-circle"
            cx="130"
            cy="130"
            r="100"
            :stroke-dasharray="circumference"
            :stroke-dashoffset="progressOffset"
          />
        </svg>
        <div class="shield">
          <span class="shield-value">{{ progressPercent }}%</span>
          <span class="shield-label">匹配进度</span>
        </div>
      </div>

      <div class="loading-subtitle"><span></span>正在检测资金匹配中</div>

      <div class="loading-steps">
        <div class="loading-step">
          <div class="step-check done">✓</div>
          <span>实名认证检测</span>
        </div>
        <div class="loading-step">
          <div class="step-check done">✓</div>
          <span>基本信息检测</span>
        </div>
        <div class="loading-step">
          <div class="step-check done">✓</div>
          <span>风控审批</span>
        </div>
        <div class="loading-step">
          <div class="step-check" :class="progressPercent >= 100 ? 'done' : 'spinning'">
            <span v-if="progressPercent >= 100">✓</span>
          </div>
          <span>资金匹配中</span>
        </div>
      </div>
      <div class="loading-safe"><span>✓</span>全程加密保护，请放心等待</div>
    </div>

    <!-- 渠道 weibowallethalf / weibozhuanH5 + 非安卓：引导在浏览器中打开 -->
    <div v-show="showIosGuide" class="ios-guide-mask" @click="showIosGuide = false">
      <div class="ios-guide-pop">
        <img class="ios-guide-arrow" src="../../assets/images/icon_share.png" alt="" />
        <div class="ios-guide-text">
          <p class="ios-guide-main">
            点击右上角 <span class="ios-guide-dots">···</span> 图标，选择
            <span class="ios-guide-browser">
              <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                <circle cx="12" cy="12" r="10" fill="#4A90E2" />
                <ellipse
                  cx="12"
                  cy="12"
                  rx="4"
                  ry="10"
                  fill="none"
                  stroke="#fff"
                  stroke-width="1.5"
                />
                <path
                  d="M2 12h20M4.5 7h15M4.5 17h15"
                  fill="none"
                  stroke="#fff"
                  stroke-width="1.5"
                />
              </svg>
              <b>浏览器打开</b>
            </span>
          </p>
          <p class="ios-guide-sub">若浏览器打开失败，请到应用市场搜索【闪借花】</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://res.wx.qq.com/open/js/jweixin-1.6.2.js"></script>
<script>
import Cookies from 'js-cookie'
import * as API_Common from '@/api/common.js'
import { setEncryption } from '@/utils/encrypt'
import { isInTGFrame, navigateTGFrameOrSelf } from '@/utils/tgFrame'

// 指定渠道统一下载 public 目录中的审核版安装包
const FIXED_ANDROID_APK_PATH = '/app-1.0.22-1023-sjhreview-release.apk'
const GUIDE_CHANNELS = ['weibowallethalf', 'weibozhuanH5']

/**
 * 打开外部链接 聚合花钱入代码
 * @param {string} url - 要打开的外部链接地址
 */
function openExternalUrl(url) {
  if (typeof wx === 'undefined' || !wx.miniProgram || !wx.miniProgram.navigateTo) {
    console.error('wx.miniProgram.navigateTo 不可用，请确保在微信 web-view 环境中运行')
    return false
  }

  try {
    // 页面路径（我方已配置）
    const targetPage = '/pages/web-view/web-view'
    // 通过 URL 参数传递要打开的链接
    const targetUrl = `${targetPage}?url=${encodeURIComponent(url)}&action=openUrl`

    wx.miniProgram.navigateTo({
      url: targetUrl,
      success: function (res) {
        console.log('跳转成功', res)
      },
      fail: function (err) {
        console.error('跳转失败', err)
      },
    })
    return true
  } catch (error) {
    console.error('打开外部链接失败', error)
    return false
  }
}

/** 渠道 source → 贷超列表静态页文件名 */
const PRODUCT_LIST_HTML_BY_SOURCE = {
  renpinjiekuan: 'productListTl3.html',
  huiyihua: 'productListSjh.html',
  yangxiaomie: 'productListCchjq.html',
  sjhreview: 'productListSjh2.html',
}
const DEFAULT_PRODUCT_LIST_HTML = 'productListOrange.html'

export default {
  name: 'ResultHalfLoanLoadingFlow',
  props: {
    flowQuery: {
      type: Object,
      default: null,
    },
    autoStart: {
      type: Boolean,
      default: true,
    },
    externalFallback: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const initialQuery = this.flowQuery || (this.$route && this.$route.query) || {}

    return {
      runtimeQuery: initialQuery,
      channel: initialQuery.source,
      brand: initialQuery.brand,
      sign: initialQuery.sign,
      tsp: initialQuery.tsp,
      processId: initialQuery.processId || '',
      started: false,
      fallbackEmitted: false,

      pageMode: 'loading', // 'loading' | 'intercept'

      // ── 下载页（intercept）相关 ──
      downAppUrl: undefined,
      showIosGuide: false, // iOS 浏览器打开引导

      // ── Loading 页相关 ──
      circumference: 2 * Math.PI * 100,
      progressPercent: 25,
      progressTimer: null,
      pollTimer: null, // 轮询定时器
      polling: false, // 是否正在轮询
      submittingEntry: false, // 撞库进件防重入
      redirecting: false, // 跳转防重入
      startTime: null,
      MAX_WAIT_MS: 10000,
      POLL_INTERVAL: 2000,

      h5ChannelCode: '', // 撞库接口使用的渠道码， getReturnUrl 接口返回
    }
  },
  computed: {
    queryParams() {
      return this.runtimeQuery || this.flowQuery || (this.$route && this.$route.query) || {}
    },
    isTGFrame() {
      return isInTGFrame()
    },
    progressOffset() {
      return this.circumference - (this.progressPercent / 100) * this.circumference
    },
    fallbackUrl() {
      // 正式环境使用更新后的下载页域名；开发、测试和灰度回到当前站点，避免兜底流程串到生产环境。
      const origin =
        process.env.VUE_APP_RUNTIME_ENV === 'production'
          ? 'https://apiprod.zhongkeqirui.com'
          : window.location.origin
      return `${origin}/downloadApp_themeTwo?source=${encodeURIComponent(this.channel || '')}`
    },
    // 渠道 weibowallethalf / weibozhuanH5 需区分安卓 / iOS 下载引导
    needOsDownloadGuide() {
      const channel = this.queryParams.source || this.channel
      return GUIDE_CHANNELS.indexOf(channel) !== -1
    },
    downloadTargetUrl() {
      if (this.brand === 'xiaomi') return 'https://app.xiaomi.com/detail/1500555'
      return this.downAppUrl
    },
  },
  created() {
    window.__TRACK_SCENE_KEY__ = 'resultHalfLoanLoading'
  },
  mounted() {
    if (this.autoStart) this.start()
  },
  beforeDestroy() {
    window.__TRACK_SCENE_KEY__ = ''
    if (this.progressTimer) clearInterval(this.progressTimer)
    if (this.pollTimer) clearInterval(this.pollTimer)
  },
  methods: {
    start(flowQuery) {
      if (this.started || this.fallbackEmitted) return
      // 独立下载入口会在前置接口完成后传入 URL 参数，后续流程始终读取这份快照。
      if (flowQuery) this.runtimeQuery = flowQuery
      const query = this.queryParams

      // 公共组件可能先展示后启动，启动时再同步接口 URL 中解析出的流程参数。
      this.channel = query.source
      this.brand = query.brand
      this.sign = query.sign
      this.tsp = query.tsp
      this.processId = query.processId || ''
      this.started = true

      try {
        const recordRequest = this.setRecordAccess()
        if (this.externalFallback && recordRequest && typeof recordRequest.catch === 'function') {
          recordRequest.catch((error) => this.enterInterceptMode(error))
        }
        this.fetchHalfReturnUrl()
      } catch (error) {
        this.enterInterceptMode(error)
      }
    },
    trackContext(extra = {}) {
      const ctx = { remark: this.processId, ...extra }
      const userId = this.queryParams.userId
      if (userId != null && userId !== '') ctx.userId = userId
      return ctx
    },
    /** API半流程 loading 页 PV（TRACK_MAP default:100012） */
    trackUnionLoadingPv() {
      API_Common.handleBatchTrackBase(100012, this.trackContext())
    },
    /** 城市拦截下载引导页 PV（TRACK_MAP default:100086） */
    trackInterceptDownloadPv() {
      API_Common.handleBatchTrackBase(100086, this.trackContext())
    },
    /** 查询半流程处理结果；status=0 时由 ensureLoadingPoll 定时继续调用本方法 */
    async fetchHalfReturnUrl() {
      if (this.polling) return
      this.polling = true
      const isInitial = !this.pollTimer

      try {
        const resp = await API_Common.getHalfReturnUrl({
          source: this.channel,
          processId: this.processId,
          sign: this.sign,
        })
        // 已进入兜底或跳转阶段时忽略迟到的轮询响应，避免同一次流程触发第二个跳转。
        if (this.fallbackEmitted || this.redirecting) return
        console.log('半流程接口返回信息:', JSON.stringify(resp.data || {}))

        if (!resp) {
          if (this.externalFallback) {
            this.enterInterceptMode(new Error('半流程接口未返回有效数据'))
          } else if (isInitial) {
            this.handleHalfReturnPayload(null, { isInitial })
          }
          return
        }

        const payload = resp?.data !== undefined ? resp.data : resp
        this.handleHalfReturnPayload(payload, { isInitial })
      } catch (e) {
        console.error('fetchHalfReturnUrl error:', e)
        if (this.externalFallback) {
          this.enterInterceptMode(e)
          return
        }
        if (isInitial) {
          this.pageMode = 'loading'
          this.trackUnionLoadingPv()
          this.ensureLoadingPoll()
          this.$nextTick(() => this.fetchHalfReturnUrl())
        }
      } finally {
        this.polling = false
      }
    },
    /** 处理半流程返回数据 */
    handleHalfReturnPayload(payload, { isInitial = false } = {}) {
      if (this.fallbackEmitted || this.redirecting) return
      const status = Number(payload?.status)

      if (status === 5) {
        // 城市拦截
        this.enterInterceptMode()
        return
      }

      if (isInitial) {
        // 初始状态
        this.pageMode = 'loading'
        this.trackUnionLoadingPv()
      }

      // 需要调用撞库接口 甜瓜的流程
      if (payload?.userDetailVO && payload?.accessToken) {
        Cookies.set('token', payload.accessToken, { path: '/' })
        this.h5ChannelCode = payload.h5ChannelCode

        if (!this.submittingEntry) {
          this.callCrashLibraryInterface(payload.userDetailVO)
        }
        return
      }

      if (status === 0) {
        // 处理中 轮训中
        this.ensureLoadingPoll()
        return
      }

      if (!this.progressTimer) {
        // 开始进度动画
        this.startProgressAnimation()
      }
      // 跳转
      this.finishAndRedirect(payload?.returnUrl || this.fallbackUrl)
    },
    /** 确保轮询 */
    ensureLoadingPoll() {
      if (this.pollTimer) return

      this.startTime = Date.now()
      this.startProgressAnimation()
      this.pollTimer = setInterval(() => {
        if (Date.now() - this.startTime >= this.MAX_WAIT_MS) {
          this.finishAndRedirect(this.fallbackUrl)
          return
        }
        this.fetchHalfReturnUrl()
      }, this.POLL_INTERVAL)
    },
    /**
     * 将 userDetailVO 转为 submitAnEntry 入参
     * 字段处理与 entry_sjh getUserDetail 回显 + 表单提交保持一致
     */
    buildEntrySubmitData(data) {
      const q = this.queryParams || {}
      const userName = data.userName || data.realName || ''
      const idCard = data.idCard || ''

      const showCarInfo =
        data.showCarInfo !== undefined && data.showCarInfo !== null ? Number(data.showCarInfo) : 1

      const isCar = data.isCar !== undefined && data.isCar !== null ? Number(data.isCar) : 0

      // 个人资产：与 entry_sjh getUserDetail creditType 回显逻辑对应
      const assets = []
      const assetFields = [
        ['room', 1],
        ['vehicle', 2],
        ['providentFund', 3],
        ['socialSecurity', 4],
        ['businessInsurance', 5],
        ['businessOwners', 6],
      ]
      assetFields.forEach(([key, dictValue]) => {
        if (data[key]) assets.push(dictValue)
      })

      let loanPeriod = data.loanPeriod
      if (loanPeriod != null && loanPeriod !== '') {
        loanPeriod = parseInt(loanPeriod, 10) === 9 ? 12 : parseInt(loanPeriod, 10)
      } else if (q.period) {
        loanPeriod = parseInt(q.period, 10) === 9 ? 12 : parseInt(q.period, 10)
      } else {
        loanPeriod = 6
      }

      const loanAmount = q.amount || data.loanAmount || 100000
      const datas = {
        channelNo: this.h5ChannelCode, //
        loanAmount,
        loanPurpose: data.loanPurpose || q.purpose,
        loanPeriod,
        realName: setEncryption(userName),
        idCard: setEncryption(idCard),
        credit: data.sesameCreditScore || data.credit || '650-700',
        assets,
        gpsCityName: data.gpsCityName || '',
        cityId: data.cityId || '',
        provinceId: data.provinceId || '',
        creditInformation: data.creditInformation || '',
        occupation: data.occupation || '',
        showCarInfo,
        isCar,
        plateNumber: data.plateNumber || '',
        carAge:
          data.carAge !== undefined && data.carAge !== null && data.carAge !== ''
            ? data.carAge
            : '',
        carPurchaseMethod:
          data.carPurchaseMethod !== undefined &&
          data.carPurchaseMethod !== null &&
          data.carPurchaseMethod !== ''
            ? data.carPurchaseMethod
            : '',
      }

      if (q.trackId) {
        datas.trackId = q.trackId
      }
      if (q.processId) {
        datas.processId = q.processId
      }

      return datas
    },
    // 此处调用撞库接口
    async callCrashLibraryInterface(data) {
      if (this.submittingEntry) return
      this.submittingEntry = true
      this.clearLoadingTimers()
      try {
        if (data.userId) {
          localStorage.setItem('userId', data.userId)
        }

        const datas = this.buildEntrySubmitData(data)
        let res = await API_Common.submitAnEntry(datas)
        console.log('撞库返回信息 response2:', JSON.stringify(res.data || {}))

        if (res?.code === 200 && res.data) {
          // 撞库成功跳转到协议页面
          if (res.data.hasPushSuccess == 1) {
            const successRoute = {
              path: '/result_zk_suc_comn',
              query: {
                applyId: res.data.applyId,
                hasPushSuccess: res.data.hasPushSuccess,
                realName: data.userName,
                loanAmount: datas.loanAmount,
                idCard: datas.idCard,
                productId: res.data.productId,
                apiReqType: 1, // 撞库成功接口没返回这个字段，与后台约定写死1
                source: this.channel,
                loanSuperPageRedirectRule: res.data.loanSuperPageRedirectRule,
                isH5DownloadAppShow: res.data.isH5DownloadAppShow,
                isRedirectProductsPage: res.data.isRedirectProductsPage,
                downPageUrlTid: res.data.downPageUrlTid,
                applyPageUrlTid: res.data.applyPageUrlTid,
                downPageUrl: res.data.downPageUrl,
                processId: this.processId || '',
                isHalfOneApply: res.data.isHalfOneApply, // 1 就是默推
                isMorePush: this.queryParams.isMorePush, // 半流程多推
                h5ChannelCode: this.h5ChannelCode, // 撞库接口使用的渠道码
              },
            }

            if (this.externalFallback) {
              // 独立下载入口不渲染 router-view，必须整页跳转才能加载主站目标路由。
              window.location.replace(this.$router.resolve(successRoute).href)
            } else {
              this.$router.push(successRoute)
            }
          } else {
            this.handleEntryFailureRedirect(res.data)
          }
        } else {
          console.log('撞库接口报错')
          // 显示屏蔽城市拦截页面
          this.enterInterceptMode()
        }
      } catch (error) {
        console.log('撞库接口报错', JSON.stringify(error))
        // 显示屏蔽城市拦截页面
        this.enterInterceptMode()
      }
    },
    /** 撞库未匹配成功：优先三方链接，否则按撞库返回的贷超字段跳列表或下载页 */
    handleEntryFailureRedirect(entryData) {
      const fallbackNavigate = () => {
        if (entryData.isRedirectProductsPage === 1) {
          this.goProductListPage(100019, 1000, entryData.productId)
        } else {
          this.goResultLoanThemeTwo(1000, entryData.productId)
        }
      }

      API_Common.getHalfDownloadUrl(this.channel, this.processId, this.h5ChannelCode)
        .then((downloadRes) => {
          console.log('三方跳转 response3:', JSON.stringify(downloadRes.data || {}))

          if (downloadRes?.code === 200 && downloadRes?.data?.url) {
            API_Common.handleBatchTrackBase(100058, { remark: downloadRes.data.url })
            window.location.href = downloadRes.data.url
          } else {
            fallbackNavigate()
          }
        })
        .catch((error) => {
          if (this.externalFallback) this.enterInterceptMode(error)
          else fallbackNavigate()
        })
    },
    /** 跳转兜底下载结果页 result_loan_themeTwo（埋点 100020） */
    goResultLoanThemeTwo(delayMs, productId) {
      this.scheduleNavigate(() => {
        API_Common.handleBatchTrackBase(100020, {
          remark: '产品一;' + (productId || ''),
        })
        window.location.href = `/result_loan_themeTwo?source=${
          this.channel
        }&tsp=${Date.now()}&processId=${this.processId}`
      }, delayMs)
    },
    /**
     * 跳转贷超列表页
     * @param {number|null} trackEvent - 埋点事件号，null 则不埋点
     * @param {number} delayMs - 延迟毫秒
     */
    goProductListPage(trackEvent, delayMs, productId) {
      this.scheduleNavigate(() => {
        if (trackEvent) {
          if (trackEvent === 100019) {
            API_Common.handleBatchTrackBase(trackEvent, {
              remark: '产品一;' + (productId || ''),
            })
          } else {
            API_Common.handleBatchTrackBase(trackEvent)
          }
        }
        window.location.href = `/${this.productListHtml()}?source=${this.channel}&tsp=${Date.now()}`
      }, delayMs)
    },
    /** 延迟跳转；delayMs 为 0 时立即执行 */
    scheduleNavigate(fn, delayMs) {
      if (delayMs > 0) setTimeout(fn, delayMs)
      else fn()
    },
    /** 按当前渠道 source 解析贷超列表页 HTML 文件名 */
    productListHtml() {
      return PRODUCT_LIST_HTML_BY_SOURCE[this.channel] || DEFAULT_PRODUCT_LIST_HTML
    },
    clearLoadingTimers() {
      if (this.progressTimer) {
        clearInterval(this.progressTimer)
        this.progressTimer = null
      }
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    enterInterceptMode(error) {
      this.clearLoadingTimers()
      if (this.externalFallback) {
        if (this.fallbackEmitted) return
        this.fallbackEmitted = true
        this.$emit('fallback', error)
        return
      }
      this.pageMode = 'intercept'
      this.trackInterceptDownloadPv()
      this.getDownloadUrl()
    },
    // ================== 下载页逻辑 ==================
    getUa() {
      return (navigator.userAgent || '').toLowerCase()
    },
    isWeixin() {
      return this.getUa().indexOf('micromessenger') !== -1
    },
    isAndroidClient() {
      return /android/i.test(navigator.userAgent || '') || this.client === 'android'
    },
    isInAppBrowser() {
      const ua = this.getUa()
      return (
        ua.indexOf('micromessenger') !== -1 ||
        ua.indexOf('weibo') !== -1 ||
        ua.indexOf('qq/') !== -1
      )
    },
    getFixedAndroidApkUrl() {
      return `${window.location.origin}${FIXED_ANDROID_APK_PATH}`
    },
    // 下载：指定渠道安卓 → 固定 apk；内置浏览器非安卓/微信 → 引导；其余直接跳转
    handleDownload() {
      API_Common.handleBatchTrackBase(100087, this.trackContext())

      if (this.needOsDownloadGuide && this.isAndroidClient()) {
        navigateTGFrameOrSelf(this.getFixedAndroidApkUrl())
        return
      }

      if (
        (this.needOsDownloadGuide && this.isInAppBrowser() && !this.isAndroidClient()) ||
        this.isWeixin()
      ) {
        this.showIosGuide = true
        return
      }

      const targetUrl = this.downloadTargetUrl
      if (!targetUrl) {
        // 下载地址仍在异步加载时留在当前页，避免用户点击后无反馈或产生空地址跳转。
        this.$toast('下载地址加载中，请稍后重试')
        this.getDownloadUrl()
        return
      }

      navigateTGFrameOrSelf(targetUrl)
    },
    onUserDownloadClick() {
      this.handleDownload()
    },
    getDownloadUrl() {
      API_Common.getDownloadUrl(this.channel).then((res) => {
        if (res.code === 200) {
          this.downAppUrl = res.data.url
        }
      })
    },
    setRecordAccess() {
      return API_Common.setRecordAccess({
        source: this.channel,
        processId: this.processId,
        sign: this.sign,
      })
    },
    startProgressAnimation() {
      this.progressPercent = 25
      this.progressTimer = setInterval(() => {
        if (this.progressPercent >= 90) {
          clearInterval(this.progressTimer)
        } else {
          this.progressPercent++
        }
      }, 154)
    },
    finishAndRedirect(url) {
      if (this.redirecting) return
      this.redirecting = true
      if (this.progressTimer) clearInterval(this.progressTimer)
      if (this.pollTimer) clearInterval(this.pollTimer)
      this.progressPercent = 100
      setTimeout(() => {
        window.location.href = url
      }, 400)
    },
  },
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  min-height: 100vh;
}

/* ===================== 下载引导页样式（同 public/download/index.html 下载模块） ===================== */
.download-box {
  min-height: 100vh;
  background-image: url('../../assets/images/entryThemeOne/result-loan-bg.png');
  background-size: 100% 6rem;
  background-repeat: no-repeat;
  background-color: #f5f5f5;
  font-size: 0.24rem;
  padding: 0.1rem 0.3rem;
  box-sizing: border-box;

  .main-title {
    padding-top: 0.5rem;
    font-size: 0.48rem;
    font-weight: 600;
    color: #333;
    margin: 0 0 0.6rem;
    text-align: center;
    img {
      width: 100%;
      height: auto;
      vertical-align: top;
    }
  }

  .main-content {
    padding: 0.01rem 0.3rem 0.5rem;
    background: linear-gradient(180deg, #ffebdf 0%, #fffefd 21.48%, #fffdfc 100%);
    border: 1px solid #fff;
    border-radius: 0.16rem;
    box-shadow: 0 0.08rem 0.24rem rgba(0, 0, 0, 0.05);

    .trapezoid {
      display: inline-block;
      position: relative;
      padding: 0.14rem 1rem;
      background: rgba(255, 186, 145, 0.38);
      color: #6c2e08;
      font-size: 0.28rem;
      font-weight: 500;
      margin-bottom: 0.4rem;
      border-radius: 0 0 0.6rem 0.6rem;
      clip-path: polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%);
      text-align: center;
      line-height: 1.4;
    }

    .auth-success {
      margin-bottom: 0.6rem;
      h2 {
        font-size: 0.8rem;
        font-weight: 600;
        color: #333;
        margin: 0 0 0.16rem;
      }
      p {
        font-size: 0.28rem;
        color: #666;
        margin: 0 0 0.5rem;
      }
    }

    .credit-module {
      position: relative;
      border-radius: 0.24rem;
      margin-bottom: 0.2rem;
      background: #f9f9f9;
      padding: 0.28rem 0.2rem;

      &.bg-rotate {
        background: linear-gradient(135deg, #fff2eb 0%, #fff6f0 100%);
        border: 1px solid #ffe6d9;
      }

      .speed-channel {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.15rem 0.2rem;

        .channel-info {
          flex: 1;

          .channel-title {
            font-size: 0.26rem;
            color: #601b00;
            margin-top: 0.08rem;
            margin-bottom: 0.18rem;
            text-align: left;
          }

          .speed-info {
            display: flex;
            align-items: center;
            font-size: 0.3rem;
            font-weight: 600;
            color: #601b00;
            text-align: left;
            margin: 0;

            .speed-icon {
              margin-left: 0.08rem;

              img {
                width: 0.24rem;
                height: 0.24rem;
                vertical-align: middle;
              }
            }
          }
        }

        .speed-quotation {
          position: absolute;
          top: 0;
          right: 0;
          font-size: 0.24rem;
          font-weight: 400;
          color: #fff;
          margin: 0;
          padding: 0.08rem 0.15rem;
          background-color: #ff6410;
          border-top-right-radius: 0.3rem;
          border-bottom-left-radius: 0.3rem;
          clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 50%);
        }
      }
    }

    .download-btn {
      width: 100%;
      height: 1rem;
      line-height: 1rem;
      padding: 0;
      background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
      border-radius: 0.5rem;
      font-size: 0.32rem;
      font-weight: 500;
      color: #fff !important;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.24rem;

      .download-icon {
        width: 0.32rem;
        height: auto;
        margin-right: 0.12rem;
        vertical-align: middle;
      }

      span {
        margin-left: 0;
      }
    }

    .download-tips {
      font-size: 0.24rem;
      color: #999;
      margin: 0;
    }
  }

  .tips-section {
    padding: 0.2rem;
    margin: 0.3rem 0 0.6rem;
    background: #fffbf9;
    border-radius: 0.24rem;

    .tips-text {
      font-size: 0.22rem;
      color: #75280b;
      line-height: 1.5;
      text-align: left;
      margin: 0;
    }
  }

  .steps-section {
    background: linear-gradient(180deg, #fff9f6 0%, #ffffff 16.39%, #ffffff 100%);
    margin: 0.32rem 0;
    padding: 0.4rem;
    border-radius: 0.24rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .steps-title {
      font-size: 0.32rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 0.32rem;
      color: #333;
      display: flex;
      align-items: flex-end;
      justify-content: center;

      .header-line {
        width: 1rem;
        height: auto;
        margin-bottom: 0.15rem;

        &.left {
          transform: rotate(180deg);
        }
      }

      .steps-title-text {
        margin: 0 0.2rem;
      }
    }

    .steps-container {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .step-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;

        .step-icon {
          width: 0.7rem;
          height: 0.7rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0.16rem;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .step-text {
          font-size: 0.2rem;
          font-weight: 600;
          color: #4b2209;
        }
      }

      .step-arrow {
        flex: 0.5;
        display: flex;
        justify-content: center;

        img {
          width: 0.7rem;
          height: 0.16rem;
          margin-bottom: 0.4rem;
        }
      }
    }
  }
}

.tg-frame .download-box {
  background: linear-gradient(180deg, #1fbf75 0%, #1fbf75 36%, #f3f4f6 36%, #f3f4f6 100%);
  background-image: none;
  background-color: #f3f4f6;
  color: #1a2744;

  .main-content {
    background: #fff;
    border-color: #fff;
    box-shadow: 0 0.08rem 0.24rem rgba(31, 191, 117, 0.12);

    .trapezoid {
      background: rgba(31, 191, 117, 0.18);
      color: #1a6640;
    }

    .auth-success {
      h2 {
        color: #1a2744;
      }

      p {
        color: #888;
      }
    }

    .credit-module {
      background: #f5fbf7;

      &.bg-rotate {
        background: linear-gradient(135deg, #edfbf3 0%, #e8f8ef 100%);
        border-color: #c8eed9;
      }

      .speed-channel {
        .channel-info {
          .channel-title {
            color: #1a2744;
          }

          .speed-info {
            color: #1a2744;
          }
        }

        .speed-quotation {
          background-color: #1fbf75;
        }
      }
    }

    .download-btn {
      background: linear-gradient(90deg, #ff8a45 0%, #ff5c1a 100%);
      box-shadow: 0 0.12rem 0.28rem rgba(255, 92, 26, 0.28);
    }

    .download-tips {
      color: #888;
    }
  }

  .tips-section {
    background: #f0faf4;

    .tips-text {
      color: #666;
    }
  }

  .steps-section {
    background: linear-gradient(180deg, #f5fbf7 0%, #ffffff 16.39%, #ffffff 100%);
    box-shadow: 0 2px 10px rgba(31, 191, 117, 0.08);

    .steps-title {
      color: #1a2744;
    }

    .steps-container {
      .step-item {
        .step-text {
          color: #666;
        }
      }
    }
  }
}

/* ===================== Loading 页样式（同 union_loading） ===================== */
.tg-frame .loading-box {
  background: linear-gradient(180deg, #1fbf75 0%, #1fbf75 36%, #f3f4f6 36%, #f3f4f6 100%);
  color: #1a2744;

  .loading-title {
    color: #fff;
  }

  .glow {
    box-shadow: 0 0 40px rgba(31, 191, 117, 0.28);
  }

  .bg-circle {
    stroke: rgba(255, 255, 255, 0.45);
  }

  .progress-circle {
    stroke: #1fbf75;
  }

  .shield {
    background: linear-gradient(180deg, #1fbf75 0%, #17a866 100%);
    box-shadow: 0 10px 20px rgba(31, 191, 117, 0.28);
    color: #fff;
  }

  .loading-subtitle {
    color: #1a2744;
  }

  .loading-desc {
    color: #888;
  }

  .loading-step {
    color: #666;

    .done {
      background: #1fbf75;
      color: #fff;
    }

    .spinning {
      border-color: #c8eed9;
      border-top-color: #1fbf75;
    }
  }
}
.loading-box {
  position: relative;
  min-height: 100vh;
  padding: 0.7rem 0.44rem 0.5rem;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #5b2a16;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  background: radial-gradient(circle at 50% 28%, rgba(255, 185, 132, 0.5), transparent 32%),
    linear-gradient(160deg, #fff8f2 0%, #fff0e5 48%, #fffaf6 100%);

  .loading-light {
    position: absolute;
    width: 4.2rem;
    height: 4.2rem;
    border-radius: 50%;
    filter: blur(0.3rem);
    opacity: 0.32;
    background: linear-gradient(135deg, #ff7a35, #ffc28f);
    animation: light-float 5s ease-in-out infinite;
    pointer-events: none;
  }

  .loading-light-left {
    top: -2.1rem;
    left: -2.3rem;
  }

  .loading-light-right {
    right: -2.5rem;
    bottom: -1.7rem;
    animation-delay: -2.5s;
  }

  .loading-brand {
    position: relative;
    z-index: 2;
    display: inline-flex;
    align-items: center;
    padding: 0.12rem 0.28rem;
    border: 1px solid rgba(255, 113, 45, 0.2);
    border-radius: 0.4rem;
    color: #9b4b24;
    font-size: 0.24rem;
    letter-spacing: 0.02rem;
    background: rgba(255, 255, 255, 0.66);
    box-shadow: 0 0.12rem 0.4rem rgba(214, 91, 31, 0.08);
    backdrop-filter: blur(0.16rem);

    span {
      width: 0.14rem;
      height: 0.14rem;
      margin-right: 0.12rem;
      border-radius: 50%;
      background: #ff6b2c;
      box-shadow: 0 0 0 0.08rem rgba(255, 107, 44, 0.14);
      animation: brand-pulse 1.6s ease-out infinite;
    }
  }

  .loading-title {
    position: relative;
    z-index: 2;
    margin-top: 0.38rem;
    font-size: 0.42rem;
    line-height: 1.35;
    font-weight: 700;
    color: #54220e;
  }

  .loading-desc {
    position: relative;
    z-index: 2;
    margin-top: 0.12rem;
    color: #a67660;
    font-size: 0.25rem;
  }

  .progress-wrapper {
    position: relative;
    width: 5.2rem;
    height: 5.2rem;
    margin-top: 0.24rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .glow {
    position: absolute;
    inset: 0.45rem;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 126, 58, 0.2), rgba(255, 126, 58, 0));
    box-shadow: 0 0 0.9rem rgba(255, 112, 43, 0.25);
    animation: glow-breathe 2.4s ease-in-out infinite;
  }

  .orbit {
    position: absolute;
    border: 1px solid rgba(255, 121, 54, 0.24);
    border-radius: 50%;
    animation: orbit-spin 7s linear infinite;

    i {
      position: absolute;
      width: 0.12rem;
      height: 0.12rem;
      border-radius: 50%;
      background: #ff742f;
      box-shadow: 0 0 0.2rem rgba(255, 116, 47, 0.8);
    }
  }

  .orbit-outer {
    inset: 0.08rem;

    i:nth-child(1) {
      top: 0.42rem;
      left: 0.65rem;
    }

    i:nth-child(2) {
      top: 1.02rem;
      right: 0.22rem;
    }

    i:nth-child(3) {
      bottom: 0.32rem;
      left: 1.2rem;
    }
  }

  .orbit-inner {
    inset: 0.46rem;
    border-style: dashed;
    animation-direction: reverse;
    animation-duration: 5s;

    i:nth-child(1) {
      top: -0.06rem;
      left: 50%;
    }

    i:nth-child(2) {
      right: 0.14rem;
      bottom: 0.62rem;
    }
  }

  svg {
    position: relative;
    z-index: 2;
    width: 4.6rem;
    height: 4.6rem;
    transform: rotate(-90deg);
    filter: drop-shadow(0 0.08rem 0.18rem rgba(255, 107, 44, 0.2));
  }

  .bg-circle {
    fill: none;
    stroke: rgba(255, 255, 255, 0.8);
    stroke-width: 12;
  }

  .progress-circle {
    fill: none;
    stroke: url(#grad);
    stroke-width: 12;
    stroke-linecap: round;
    transition: stroke-dashoffset 0.5s ease;
  }

  .shield {
    position: absolute;
    z-index: 3;
    top: 50%;
    left: 50%;
    width: 2.2rem;
    height: 2.45rem;
    transform: translate(-50%, -50%);
    clip-path: polygon(50% 0%, 90% 18%, 88% 68%, 50% 100%, 12% 68%, 10% 18%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    background: linear-gradient(155deg, #ff9b55 0%, #ff641f 58%, #f14b12 100%);
    box-shadow: 0 0.28rem 0.5rem rgba(224, 76, 19, 0.28);

    &::after {
      content: '';
      position: absolute;
      top: 0.16rem;
      left: 0.32rem;
      width: 0.55rem;
      height: 1.25rem;
      transform: rotate(24deg);
      border-radius: 50%;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0.3), transparent);
    }
  }

  .shield-value {
    position: relative;
    z-index: 1;
    font-size: 0.6rem;
    line-height: 1;
    font-weight: 800;
    letter-spacing: -0.02rem;
  }

  .shield-label {
    position: relative;
    z-index: 1;
    margin-top: 0.16rem;
    font-size: 0.2rem;
    letter-spacing: 0.04rem;
    opacity: 0.88;
  }

  .loading-subtitle {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    margin-top: 0.12rem;
    color: #6a2d14;
    font-size: 0.3rem;
    font-weight: 600;

    span {
      width: 0.12rem;
      height: 0.12rem;
      margin-right: 0.14rem;
      border-radius: 50%;
      background: #ff6a25;
      box-shadow: 0 0 0.18rem rgba(255, 106, 37, 0.8);
      animation: status-blink 1.2s ease-in-out infinite;
    }

    &::after {
      content: '...';
      width: 0.34rem;
      overflow: hidden;
      text-align: left;
      animation: dot-typing 1.4s steps(4, end) infinite;
    }
  }

  .loading-steps {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 6.2rem;
    margin-top: 0.38rem;
    padding: 0.16rem 0.34rem;
    box-sizing: border-box;
    border: 1px solid rgba(255, 126, 58, 0.12);
    border-radius: 0.28rem;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0 0.22rem 0.65rem rgba(160, 70, 27, 0.1);
    backdrop-filter: blur(0.18rem);
  }

  .loading-step {
    position: relative;
    display: flex;
    align-items: center;
    height: 0.68rem;
    color: #7b4a34;
    font-size: 0.25rem;

    &:not(:last-child)::after {
      content: '';
      position: absolute;
      left: 0.15rem;
      top: 0.5rem;
      width: 1px;
      height: 0.36rem;
      background: linear-gradient(#ffb28a, rgba(255, 178, 138, 0.15));
    }

    .step-check {
      z-index: 1;
      width: 0.3rem;
      height: 0.3rem;
      margin-right: 0.2rem;
      box-sizing: border-box;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.18rem;
    }

    .done {
      color: #fff;
      background: linear-gradient(135deg, #ff9c5b, #ff641f);
      box-shadow: 0 0.08rem 0.18rem rgba(255, 100, 31, 0.22);
    }

    .spinning {
      border: 0.04rem solid #ffd8c4;
      border-top-color: #ff641f;
      animation: step-spin 0.9s linear infinite;
    }
  }

  .loading-safe {
    position: relative;
    z-index: 2;
    margin-top: 0.28rem;
    color: #ad7c65;
    font-size: 0.21rem;

    span {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 0.26rem;
      height: 0.26rem;
      margin-right: 0.08rem;
      border-radius: 50%;
      color: #fff;
      font-size: 0.16rem;
      background: #ff7a36;
    }
  }

  @keyframes light-float {
    0%,
    100% {
      transform: translate3d(0, 0, 0) scale(1);
    }
    50% {
      transform: translate3d(0.25rem, 0.22rem, 0) scale(1.08);
    }
  }

  @keyframes brand-pulse {
    70% {
      box-shadow: 0 0 0 0.18rem rgba(255, 107, 44, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 107, 44, 0);
    }
  }

  @keyframes glow-breathe {
    0%,
    100% {
      transform: scale(0.94);
      opacity: 0.6;
    }
    50% {
      transform: scale(1.06);
      opacity: 1;
    }
  }

  @keyframes orbit-spin {
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes status-blink {
    50% {
      opacity: 0.35;
      transform: scale(0.75);
    }
  }

  @keyframes dot-typing {
    from {
      width: 0;
    }
    to {
      width: 0.34rem;
    }
  }

  @keyframes step-spin {
    to {
      transform: rotate(360deg);
    }
  }
}

@media (max-height: 680px) {
  .loading-box {
    padding-top: 0.35rem;

    .loading-title {
      margin-top: 0.22rem;
    }

    .progress-wrapper {
      width: 4.4rem;
      height: 4.4rem;
      margin-top: 0.06rem;
      transform: scale(0.88);
    }

    .loading-steps {
      margin-top: 0.16rem;
    }

    .loading-safe {
      margin-top: 0.16rem;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .loading-box {
    .loading-light,
    .glow,
    .orbit,
    .loading-brand span,
    .loading-subtitle span,
    .loading-subtitle::after,
    .spinning {
      animation: none !important;
    }
  }
}

.ios-guide-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}

.ios-guide-pop {
  position: relative;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 0.32rem;
}

.ios-guide-arrow {
  display: block;
  width: 3.38rem;
  height: 4.8rem;
  position: absolute;
  right: 0.44rem;
  top: 0.34rem;
}

.ios-guide-text {
  position: absolute;
  top: 5.2rem;
  left: 0;
  width: 100%;
  padding: 0 0.6rem;
  text-align: center;
  box-sizing: border-box;
  color: #fff;
}

.ios-guide-main {
  margin: 0;
  font-size: 0.34rem;
  line-height: 0.52rem;
  font-weight: 500;
  color: #fff;
}

.ios-guide-dots {
  display: inline-block;
  padding: 0 0.06rem;
  font-size: 0.4rem;
  font-weight: 700;
  letter-spacing: 0.02rem;
  vertical-align: middle;
  color: #fff;
}

.ios-guide-browser {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  color: #fff;

  svg {
    margin: 0 0.06rem;
    flex-shrink: 0;
  }

  b {
    font-weight: 600;
    color: #fff;
  }
}

.ios-guide-sub {
  margin: 0.28rem 0 0;
  font-size: 0.26rem;
  line-height: 0.4rem;
  color: rgba(255, 255, 255, 0.85);
}
</style>
